import { createTheme } from '@mui/material/styles';
import { tokens } from './tokens';
import { typography } from './typography';

const focusRing = `0 0 0 3px ${tokens.ivory}, 0 0 0 5px ${tokens.gold}`;

export const theme = createTheme({
  palette: {
    primary: {
      main: tokens.navy,
      dark: tokens.darkNavy,
      contrastText: tokens.white,
    },
    secondary: {
      main: tokens.gold,
      light: tokens.softGold,
      contrastText: tokens.navy,
    },
    background: {
      default: tokens.ivory,
      paper: tokens.white,
    },
    text: {
      primary: tokens.charcoal,
      secondary: tokens.muted,
    },
    divider: tokens.line,
    error: { main: tokens.error },
  },
  typography,
  shape: { borderRadius: 2 },
  spacing: 8,
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: tokens.ivory,
          color: tokens.charcoal,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          minHeight: 48,
          paddingInline: 22,
          borderRadius: 0,
          '&:focus-visible': { boxShadow: focusRing },
        },
        containedPrimary: {
          backgroundColor: tokens.navy,
          '&:hover': { backgroundColor: tokens.darkNavy },
        },
        outlinedPrimary: {
          borderColor: tokens.navy,
          color: tokens.navy,
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
            backgroundColor: 'rgba(11, 29, 51, 0.04)',
            borderColor: tokens.navy,
          },
        },
        outlinedSecondary: {
          borderColor: 'rgba(255,255,255,0.55)',
          color: tokens.white,
          '&:hover': {
            borderColor: tokens.softGold,
            backgroundColor: 'rgba(255,255,255,0.06)',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.white,
          borderRadius: 2,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.navy,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.navy,
            borderWidth: 1,
          },
        },
        input: {
          padding: '14px 14px',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          '&.Mui-focused': { color: tokens.navy },
        },
      },
    },
    MuiContainer: {
      defaultProps: { maxWidth: 'lg' },
      styleOverrides: {
        root: {
          paddingLeft: 20,
          paddingRight: 20,
          '@media (min-width: 600px)': {
            paddingLeft: 32,
            paddingRight: 32,
          },
        },
        maxWidthLg: {
          maxWidth: 1180,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'inherit',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: tokens.ivory,
          color: tokens.charcoal,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          '&:focus-visible': { boxShadow: focusRing },
        },
      },
    },
  },
});
